import { Group } from '@era/security-sdk';
import { createActionGroup, props } from '@ngrx/store';
import { ErrorModel } from '@rocksoft/shared';
import { GroupApiActions } from '../group/group.actions';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const MemberGroupResolverActions = createActionGroup({
  source: 'Member Group Resolver',
  events: {
    'Member groups requested': props<{ group: Group }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const MemberGroupApiActions = createActionGroup({
  source: 'Group API',
  events: {
    'Member groups loaded': props<{ groups: Group[] }>(),
    'Member groups loaded error': props<{ error: ErrorModel }>(),
    'Member groups group deleted': props<{ group: Group }>(),
    'Member groups deleted error': props<{ error: ErrorModel }>(),
    'Member groups added': props<{ group: Group; groupToAdd: Group }>(),
    'Member groups added error': props<{ error: ErrorModel }>(),
  },
});

// Re-export GroupApiActions.groupDeleted for cross-store reference
export { GroupApiActions };

// ============================================================================
// UI ACTIONS (Group - using createActionGroup)
// ============================================================================

export const MemberGroupListActions = createActionGroup({
  source: 'Member Group List',
  events: {
    'Member groups deleted': props<{ group: Group }>(),
    'Member groups added': props<{ group: Group; groupToAdd: Group }>(),
  },
});
